//
//
//
//
//
//
//
//
//
//
//
//
//

import { BindsAttrs } from '@/mixins'
export default {
  mixins: [ BindsAttrs ],
  props: {
    starSize: {
      default: 14,
      type: Number
    }
  }
}
